import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-screen h-screen fixed z-50 flex flex-col items-center justify-center bg-black/50"
}
const _hoisted_2 = {
  key: 0,
  class: "self-start font-bold text-2xl uppercase"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col gap-2 h-80 overflow-scroll shadow rounded p-2 w-full"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 2,
  class: "flex w-full gap-2"
}
const _hoisted_6 = { class: "flex flex-col w-5/12 gap-1 break-word" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "addressCep",
  class: "font-semibold"
}, "Cep", -1)
const _hoisted_8 = { class: "flex flex-col w-5/12 gap-1 break-word" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "addressCity",
  class: "font-semibold"
}, "Cidade", -1)
const _hoisted_10 = { class: "flex flex-col w-2/12 gap-1 break-word" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "addressCountry",
  class: "font-semibold"
}, "Estado", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 3,
  class: "flex flex-wrap w-full"
}
const _hoisted_14 = ["for"]
const _hoisted_15 = ["placeholder", "value", "onInput"]
const _hoisted_16 = { class: "self-end flex gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _directive_maska = _resolveDirective("maska")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["bg-white h-full md:h-fit p-4 rounded flex flex-col items-center gap-4 overflow-hidden", _ctx.modalState == 'normal' ? 'w-full md:w-2/5' : 'w-full md:w-3/5'])
        }, [
          _createElementVNode("button", {
            class: "self-end",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'), _ctx.modalState = 'normal'))
          }, [
            _createVNode(_component_Icon, {
              icon: "teenyicons:x-solid",
              class: "text-cinza-padrao hover:cursor-pointer"
            })
          ]),
          (_ctx.modalState == 'normal')
            ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "Lista de endereços cadastrados:"))
            : _createCommentVNode("", true),
          (_ctx.modalState == 'normal')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.userAddress?.endereco_cadastro?.zip_code)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "bg-blue-700 text-white rounded p-2 font-bold",
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cadastro', _ctx.userAddress.endereco_cadastro), _ctx.$emit('close')))
                    }, _toDisplayString(_ctx.userAddress?.endereco_cadastro?.street) + ", N. " + _toDisplayString(_ctx.userAddress?.endereco_cadastro?.number) + ", " + _toDisplayString(_ctx.userAddress?.endereco_cadastro?.neighborhood) + " " + _toDisplayString(_ctx.userAddress?.endereco_cadastro?.city) + " - " + _toDisplayString(_ctx.userAddress?.endereco_cadastro?.state), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userAddress?.endereco_entrega, (address) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: address.id,
                    class: "bg-blue-700 text-white rounded p-2 font-bold",
                    type: "button",
                    onClick: ($event: any) => (_ctx.$emit('entrega', address), _ctx.$emit('close'))
                  }, _toDisplayString(address?.street) + " " + _toDisplayString(address?.number) + ", " + _toDisplayString(address?.neighborhood) + " " + _toDisplayString(address?.city) + " - " + _toDisplayString(address?.state), 9, _hoisted_4))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.modalState == 'creating')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cep) = $event)),
                    "data-maska": "#####-###",
                    placeholder: "Cep",
                    class: "p-1 border-2 mx-1 mb-2 focus:border-azul-claro focus:outline-none",
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getAddressViaCep(_ctx.cep)))
                  }, null, 544), [
                    [_vModelText, _ctx.cep],
                    [_directive_maska]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.city) = $event)),
                    placeholder: "Cidade",
                    class: "p-1 border-2 mx-1 mb-2 focus:border-azul-claro focus:outline-none"
                  }, null, 512), [
                    [_vModelText, _ctx.city]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state) = $event)),
                    class: "focus:outline-none p-2 border-2 focus:border-azul-claro bg-white"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (opt) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: opt.acronym,
                        value: opt.acronym
                      }, _toDisplayString(opt.acronym), 9, _hoisted_12))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.state]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.modalState == 'creating')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.address, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "flex flex-col w-1/2 gap-1 break-word"
                  }, [
                    _createElementVNode("label", {
                      for: item.id,
                      class: "font-semibold"
                    }, _toDisplayString(item.label), 9, _hoisted_14),
                    _createElementVNode("input", {
                      placeholder: item.placeholder,
                      value: item.value,
                      class: "p-1 border-2 mx-1 mb-2 focus:border-azul-claro focus:outline-none",
                      onInput: ($event: any) => (item.value = $event.target.value)
                    }, null, 40, _hoisted_15)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.modalState == 'normal')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "border-2 border-black rounded p-2 font-bold",
                  type: "button",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modalState = 'creating'))
                }, " Criar novo endereço "))
              : _createCommentVNode("", true),
            (_ctx.modalState == 'creating')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "border-2 border-black rounded p-2 font-bold",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.modalState = 'normal'))
                }, " Voltar "))
              : _createCommentVNode("", true),
            (_ctx.modalState == 'creating')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "bg-black text-white rounded p-2 border-black font-bold",
                  type: "button",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.newAddress(), _ctx.modalState = 'normal', _ctx.$emit('close')))
                }, " Criar "))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}